var _path, _path2, _g, _path3, _path4, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewStudent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 74,
    viewBox: "0 0 72 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M68.9823 49.993C61.9967 66.7402 43.3889 76.1218 27.2521 73.5912C24.6262 73.1793 17.4277 71.9528 11.0542 66.1657C-1.21503 55.0251 -3.83905 32.9654 6.05826 17.4193C13.2618 6.1045 26.1745 -0.309274 38.4443 0.0114828C41.0871 0.0806602 51.2159 0.506533 60.1174 7.97986C61.4247 9.07751 64.3086 11.686 66.9074 15.8239C73.01 25.5409 73.535 39.0786 68.9823 49.993Z",
    fill: "#0095DF"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1528_1807)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1528_1807",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 17,
    width: 40,
    height: 40
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4999 56.5V17.5001H16.5V56.5H55.4999Z",
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1528_1807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8242 53.3036V56.415",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1719 53.3036V56.415",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9336 22.6842V26.793",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1528_1807",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 17,
    width: 40,
    height: 40
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17.0001H55.9999V57H16V17.0001Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1528_1807)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7559 53.3393V54.5128C20.7559 55.5633 21.6075 56.415 22.6582 56.415H49.3401C50.3906 56.415 51.2423 55.5633 51.2423 54.5128V48.8535C51.2423 46.468 49.6701 44.3678 47.3812 43.6958L44.9508 42.9823L35.9991 48.3016L27.0479 42.9827L24.6174 43.696C22.3283 44.3679 20.7559 46.4681 20.7559 48.8538V50.6001",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9517 42.9825L39.5061 39.4256C39.5061 41.7013 38.8455 43.9281 37.6044 45.8356L36 48.3018",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0469 42.9825L32.4926 39.4256C32.4926 41.7013 33.1531 43.9281 34.3941 45.8356L35.9986 48.3018",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0618 26.8739V28.6431C31.0618 29.353 30.4863 29.9285 29.7764 29.9285H28.5V32.0304C28.5 32.5675 28.9354 33.0029 29.4725 33.0029C29.6419 33.0029 29.7798 33.1356 29.7905 33.3047C29.9956 36.5561 32.6958 39.1299 35.9988 39.1299C39.3018 39.1299 42.0021 36.5561 42.2072 33.3047C42.2179 33.1356 42.3557 33.0029 42.5252 33.0029C43.0623 33.0029 43.4978 32.5675 43.4978 32.0304V29.9285H42.2214C41.5114 29.9285 40.936 29.353 40.936 28.6431V26.8739",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4902 38.0447V39.4268L32.4928 39.4251",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5059 39.4258V38.0468",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6941 22.838L37.3994 22.5541C36.4681 22.4389 35.526 22.439 34.5947 22.5542L29.4124 23.1954L28.0176 23.368V26.299C28.0176 26.5843 28.2256 26.8205 28.4981 26.8657C28.5293 26.871 28.5609 26.8738 28.5926 26.874H43.4039C43.4353 26.874 43.4659 26.8708 43.4959 26.8661C43.7696 26.8218 43.979 26.5852 43.979 26.299V23.368L42.5814 23.1951L42.4171 23.1749",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4961 29.9287V26.8661",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.498 26.8658L28.4993 29.9287",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9783 23.368L47.992 22.6844C48.6778 22.5676 48.7447 21.6086 48.0817 21.3978L36.1989 17.6182C36.0681 17.5765 35.9275 17.5765 35.7966 17.6182L23.9137 21.3978C23.2509 21.6086 23.3177 22.5676 24.0035 22.6844L28.0183 23.3682",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6907 29.0526L21.8991 33.6992C21.8243 34.1378 22.1622 34.5381 22.6072 34.5381H25.2595C25.7043 34.5381 26.0422 34.1378 25.9675 33.6992L25.1759 29.0526",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1747 27.4214C25.1747 27.2549 25.1086 27.0953 24.9908 26.9776C24.8731 26.8599 24.7135 26.7938 24.547 26.7938H23.3171C23.1506 26.7938 22.991 26.8599 22.8733 26.9776C22.7556 27.0953 22.6895 27.2549 22.6895 27.4214V29.0527H25.1747V27.4214Z",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9878 42.8714C38.0672 43.0742 37.0583 43.1865 35.9998 43.1865C34.9412 43.1865 33.9323 43.0742 33.0117 42.8714",
    stroke: "#0095DF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1528_1807"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(16 17)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewStudent);
export default __webpack_public_path__ + "static/media/new_student.edcaffd8010cc034894c01ef8becd452.svg";
export { ForwardRef as ReactComponent };